import React, { useState } from 'react';
import "./Blogs.css"
import BlogsIn from './BlogsIn';
import DemoBlogs from './DemoBlogs';
const Blogs = () => {
    const [blogs,setBlogs]=useState(DemoBlogs)

    return (
        <div className="blogs" style={{ backgroundImage: "url(Images/bg.png)" }}>
            <div className="asdfad" style={{ backgroundImage: "url(Images/header.svg)" }}>
                <div className="svgabout-in">
                    <h1>My All Blogs Here !!</h1>
                </div>
            </div>
            <div className="blogs-in">
                <p className="headdp">i will write blogs here. wait and see. </p>
                <div className="dg">
                    {
                        blogs.map(x=><BlogsIn x={x}/>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Blogs;